// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"50c60093","239":"d63097e7","453":"93dd49ec","667":"d15cf1ee"}[chunkId] + ".chunk.js";
};